import {
  api,
  LifeSkillsMonitoringDate,
  LifeSkillsMonitoringDetails,
  PagedResultOfLifeSkillsMonitoring,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const lifeSkillsMonitoringApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    lifeSkillsMonitoringList: builder.query<
      PagedResultOfLifeSkillsMonitoring,
      { examinerId: number; pageIndex: number; pageSize: number; showDeleted?: boolean }
    >({
      query: ({ examinerId, pageIndex, pageSize, showDeleted }) => {
        return api.lifeSkillsMonitoring.getExaminerLifeSkillsMonitorings({
          examinerId,
          page: pageIndex + 1,
          count: pageSize,
          'filter.showDeleted': showDeleted,
        });
      },
      providesTags: ['LifeSkillsMonitoring'],
    }),
    lifeSkillsMonitoring: builder.query<LifeSkillsMonitoringDetails, { id: number }>({
      query: ({ id }) => {
        return api.lifeSkillsMonitoring.get({ id });
      },
      providesTags: ['LifeSkillsMonitoring'],
    }),
    lifeSkillsNextMonitoringDates: builder.query<
      LifeSkillsMonitoringDate[],
      { examinerId: number }
    >({
      query: ({ examinerId }) => {
        return api.lifeSkillsMonitoring.getNextLifeSkillsMonitoringDates({
          examinerId,
        });
      },
    }),
    canAddLifeSkillsMonitoring: builder.query<boolean, { examinerId: number }>({
      query: ({ examinerId }) => {
        return api.lifeSkillsMonitoring.canAddLifeSkillsMonitoring({
          examinerId,
        });
      },
    }),
    createLifeSkillsMonitoring: builder.mutation<
      LifeSkillsMonitoringDetails,
      LifeSkillsMonitoringDetails
    >({
      query: (monitoring) => {
        return api.lifeSkillsMonitoring.save(monitoring);
      },
      invalidatesTags: ['LifeSkillsMonitoring', 'ExaminerStatus'],
    }),
    updateLifeSkillsMonitoring: builder.mutation<
      LifeSkillsMonitoringDetails,
      LifeSkillsMonitoringDetails
    >({
      query: (monitoring) => {
        return api.lifeSkillsMonitoring.save(monitoring);
      },
      invalidatesTags: ['LifeSkillsMonitoring', 'ExaminerStatus'],
    }),
    deleteLifeSkillsMonitoring: builder.mutation<void, { id: number }>({
      query: ({ id }) => {
        return api.lifeSkillsMonitoring.delete({ id });
      },
      invalidatesTags: ['LifeSkillsMonitoring', 'ExaminerStatus'],
    }),
    restoreLifeSkillsMonitoring: builder.mutation<void, { id: number }>({
      query: ({ id }) => {
        return api.lifeSkillsMonitoring.restore({ id });
      },
      invalidatesTags: ['LifeSkillsMonitoring', 'ExaminerStatus'],
    }),
  }),
});

export const {
  useLifeSkillsMonitoringListQuery,
  useLifeSkillsMonitoringQuery,
  useLifeSkillsNextMonitoringDatesQuery,
  useCanAddLifeSkillsMonitoringQuery,
  useCreateLifeSkillsMonitoringMutation,
  useUpdateLifeSkillsMonitoringMutation,
  useDeleteLifeSkillsMonitoringMutation,
  useRestoreLifeSkillsMonitoringMutation,
} = lifeSkillsMonitoringApi;
